// extracted by mini-css-extract-plugin
module.exports = {"newProjectForm":"NewProjectModal_newProjectForm__BUMwI","newProjectFormDescription":"NewProjectModal_newProjectFormDescription__6M1HX"};